import { render, staticRenderFns } from "./_base-button.vue?vue&type=template&id=0aee1c2a&"
var script = {}
import style0 from "./_base-button.vue?vue&type=style&index=0&id=0aee1c2a&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports